import { render, staticRenderFns } from "./EditMenuPage.vue?vue&type=template&id=1d50f286"
import script from "./EditMenuPage.vue?vue&type=script&lang=js"
export * from "./EditMenuPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports